import {GraphObject, HTMLInfo} from 'gojs';

import {makeShowToolTipFn, hideToolTip} from './utils';

const {make} = GraphObject;


export const makeToolTip = (text: string) => {
  return make(HTMLInfo, {
    show: makeShowToolTipFn(text),
    hide: hideToolTip,
  /*
    since hideToolTip is very simple,
    we could have set mainElement instead of setting hide:
  mainElement: document.getElementById('toolTipDIV')
  */
  });
};
